// export let url = 'https://ginoetgiulia-preprod.lajungle.dev/';
// export let socketServer = 'https://ginoetgiulia-pusher-pp.lajungle.dev/';

export let url = 'https://gino-et-giulia.fr/';
export let socketServer = 'https://ginoetgiulia-pusher.lajungle.dev/';